import GiveFeedbackButton from '@/common/ui/GiveFeedbackButton';
import trackMixpanelEvent from '@/common/utils/mixpanel';
import { QuestionIcon } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

const MARKETING_SITE_URL = 'https://spellcaster.education';

interface MicroAppNavProps {
  feedbackSource: string;
  ctaContent?: React.ReactNode;
  helpUrl?: string;
}

export default function MicroAppNav({
  feedbackSource,
  ctaContent,
  helpUrl,
}: MicroAppNavProps) {
  const navigate = useNavigate();

  return (
    <nav className="w-full bg-white border-b border-gray-400 px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
      <img
        src="/ui/new-spellcaster-logo.svg"
        className="h-8 sm:h-10 cursor-pointer"
        alt="Spellcaster"
        onClick={() => navigate('/')}
      />

      <div className="flex items-center gap-4 sm:gap-6">
        {ctaContent}
        <a
          href={MARKETING_SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors hidden sm:block"
          onClick={() => {
            trackMixpanelEvent('Learn More About Spellcaster Clicked', {
              source: feedbackSource,
            });
          }}
        >
          Learn about Spellcaster
        </a>
        {helpUrl && (
          <a
            href={helpUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 hover:text-gray-900 transition-colors"
          >
            <QuestionIcon className="size-5" />
          </a>
        )}
        <GiveFeedbackButton requireEmail />
      </div>
    </nav>
  );
}
